module.exports = __webpack_public_path__ + "c4fb869422b2b62fd1fe8bc0d1f9a9dd.png";